export const AXIOS_TIMEOUTS = {
    standard: 5000,
    image: 300000
}
